<template>
<div 
    v-if="isModal"
    class="modal"
    id="spinner-modal"
    style="overflow:hidden"
>
    <div 
        class="v-spinner" 
        v-show="loading"
    >
        <div class="v-clip">
            <div 
                class="v-clip-rotation" 
                v-bind:style="spinnerStyle"></div>
            <h2>{{text}}</h2>
        </div>

    </div>
</div>
<div 
    v-else
    :id="`spinner-container-${modalId}`"
    class="no-modal-loader"
    :style="`background-color:${bgColor};`"
>
    <div class="v-spinner">
        <div class="v-clip">
            <div 
                class="v-clip-rotation" 
                v-bind:style="spinnerStyle"></div>
            <h2 :style="`color:${textColor};`">{{text}}</h2>
        </div>

    </div>
</div>
</template>

<script>
    export default {
        name: 'PageClipLoader',
        props: {
            text: '',
            loading: {
                type: Boolean,
                default: true
            },
            color: {
                type: String,
                default: '#5dc596'
            },
            size: {
                type: String,
                default: '35px'
            },
            radius: {
                type: String,
                default: '100%'
            },
            borderWidth: {
                type: String,
                default: '10px'
            },
            elid: {
                type: String,
                default: '0'
            },
            modal: {
                type: Boolean,
                default: true
            },
            bg : {
                type: String,
                default: '#fff'
            },
            tc : {
                type: String,
                default: '#000'
            },
        },
        data() {
            return {
                modalId: this.elid,
                isModal: this.modal,
                bgColor: this.bg,
                textColor: this.tc
            }
        },
        computed: {
            spinnerStyle () {
                return {
                    height: this.size,
                    width: this.size,
                    borderWidth: this.borderWidth,
                    borderColor: this.color + ' ' + this.color + ' transparent',
                    borderRadius: this.radius
                }
            }
        }
    }
</script>

<style>
    .no-modal-loader {
        z-index:10;
        display:block;
        margin:-15px !important;
        min-height:500px;
        height:calc(100% + 30px);
        position:absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
    }

    .no-modal-loader .v-spinner {
        height: 100%;
    }

    .v-spinner
    {
        text-align: center;
    }

    .v-spinner .v-clip-rotation
    {
        -webkit-animation: v-clipDelay 0.75s 0s infinite linear;
        animation: v-clipDelay 0.75s 0s infinite linear;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        background: transparent;
        border-style: solid;
        display: inline-block;
    }

    @-webkit-keyframes v-clipDelay
    {
        0%
        {
            -webkit-transform: rotate(0deg) scale(1);
            transform: rotate(0deg) scale(1);
        }
        50%
        {
            -webkit-transform: rotate(180deg) scale(0.8);
            transform: rotate(180deg) scale(0.8);
        }
        100%
        {
            -webkit-transform: rotate(360deg) scale(1);
            transform: rotate(360deg) scale(1);
        }
    }

    @keyframes v-clipDelay
    {
        0%
        {
            -webkit-transform: rotate(0deg) scale(1);
            transform: rotate(0deg) scale(1);
        }
        50%
        {
            -webkit-transform: rotate(180deg) scale(0.8);
            transform: rotate(180deg) scale(0.8);
        }
        100%
        {
            -webkit-transform: rotate(360deg) scale(1);
            transform: rotate(360deg) scale(1);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/spinners/PageClipLoader.vue